import { useForm } from '@tanstack/react-form'
import React from 'react'

import { SelectField } from '@Components/FormElements/UI/SelectField'
import { Button } from '@CoreComponents/Buttons/Button'
import { useTranslation } from '@Globals/Translations'
import { getStore } from '@Globals/useStorage'

import styles from './WristSize.module.scss'

const store = getStore('wrist_size', '')

export const useWristSize = () => React.useSyncExternalStore(store.subscribe, store.getSnapshot, () => '')

type WristSizeSelectorProps = {
  sizes: string[]
  withoutSubmitButton?: boolean
}

const WristSizeSelector = ({ sizes, withoutSubmitButton }: WristSizeSelectorProps) => {
  const wristSize = useWristSize()
  const { t } = useTranslation()

  const form = useForm({
    defaultValues: { size: wristSize },
    onSubmit: ({ value }) => {
      store.setValue(value.size)
    },
  })

  const selectWristSizeText = t('cms:SELECT_SIZE', { context: 'wrist' })

  return (
    <form
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault()
        form.handleSubmit()
      }}
    >
      <form.Field name="size">
        {field => (
          <SelectField
            id="wrist-size"
            label={selectWristSizeText}
            name={field.name}
            onBlur={field.handleBlur}
            onChange={(e) => {
              field.handleChange(e.target.value)
              if (withoutSubmitButton) {
                store.setValue(e.target.value)
              }
            }}
            options={sizes.map(size => ({ key: size, value: size }))}
            placeholder={selectWristSizeText}
            value={field.state.value}
            wrapperClassName={styles.selectWrapper}
          />
        )}
      </form.Field>

      {!withoutSubmitButton && (
        <form.Subscribe selector={state => [state.canSubmit, state.isSubmitting]}>
          {([canSubmit, isSubmitting]) => (
            <Button
              disabled={!canSubmit}
              fillWidth
              innerSpacing="medium"
              loading={isSubmitting}
              theme="black"
              type="submit"
            >
              {t('cms:COF_SELECT')}
            </Button>
          )}
        </form.Subscribe>
      )}
    </form>
  )
}

export default WristSizeSelector
